import React from "react";
import "./pageBottomFooter.css";
export var PageBottomFooter = function () {
    return (React.createElement("footer", { className: "page-bottom-footer", "aria-label": "Site policy links" },
        React.createElement("nav", { className: "page-bottom-footer-links", "aria-label": "Policy links" },
            React.createElement("a", { href: "/policies/privacy", target: "_blank", rel: "noopener noreferrer" }, "Privacy Policy"),
            React.createElement("a", { href: "/policies/terms", target: "_blank", rel: "noopener noreferrer" }, "Terms of Service"),
            React.createElement("a", { href: "/policies/refund", target: "_blank", rel: "noopener noreferrer" }, "Refund Policy"))));
};
